const handleTouchMove = (event) => event.preventDefault();

export const initWindowEvent = (w = window) => {
  w.addEventListener('touchmove', handleTouchMove, { passive: false });
};

export const cleanUpWindowEvent = (w = window) => {
  w.removeEventListener('touchmove', handleTouchMove);
};
